export const communities = [
  {
    id: 0,
    name: 'r/suggestmeabook',
    img: 'https://styles.redditmedia.com/t5_31t41/styles/communityIcon_331cwb44wqw41.png?width=256&s=f3698adabfe4092bf0b8dac1877879f8e556ca16',
    url: 'https://www.reddit.com/r/suggestmeabook/.json',
    members: '2.2M',
  },
  {
    id: 1,
    name: 'r/RomanceBooks',
    img: 'https://styles.redditmedia.com/t5_2sxjx/styles/communityIcon_sbqht6vsoqr61.png',
    url: 'https://www.reddit.com/r/RomanceBooks/.json',
    members: '102k',
  },
  {
    id: 2,
    name: 'r/52book',
    img: 'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcT44iQzs9wlD5t_b5XKX8CfvIYSb8VD043gXTiwIwFVySFjvyHV',
    url: 'https://www.reddit.com/r/52book/.json',
    members: '390k',
  },
  {
    id: 3,
    name: 'r/books',
    img: 'https://styles.redditmedia.com/t5_2qh4i/styles/communityIcon_d77x0sszups01.png',
    url: 'https://www.reddit.com/r/books/.json',
    members: '21.2M',
  },
  {
    id: 4,
    name: 'r/whatsthatbook',
    img: 'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcT44iQzs9wlD5t_b5XKX8CfvIYSb8VD043gXTiwIwFVySFjvyHV',
    url: 'https://www.reddit.com/r/whatsthatbook/.json',
    members: '189k',
  },
];
